/*
 * @Description: '产品中心'页面所有路由
*/

export default [
    {
        path: 'product',
        component: resolve => require(['@/views/product'], resolve),
        name: 'Product',
        meta: {
            nav: '产品中心'
        }
    },
    {
        path: 'product/:id',
        component: resolve => require(['@/views/product/detail'], resolve),
        name: 'Product_Detail',
        meta: {
            nav: '产品中心'
        }
    },
  {
    path: 'product_list',
    component: resolve => require(['@/views/product_list'], resolve),
    name: 'product_list',
    meta: {
      nav: '产品中心'
    }
  },
  {
    path: 'product_detail',
    component: resolve => require(['@/views/product_list/product_detail.vue'], resolve),
    name: 'product_detail',
    meta: {
      nav: '产品中心'
    }
  },


]



// WEBPACK FOOTER //
// ./src/router/product.js